import type { TranslationKey } from "./en";

export const zhCN: Record<TranslationKey, string> = {
  "language.label": "语言",

  "nav.signOut": "登出",
  "nav.breadcrumb": "导航路径",
  "nav.classrooms": "班级",
  "nav.schools": "学校",
  "nav.sidebar": "教师导览",
  "nav.openMenu": "打开菜单",
  "nav.closeMenu": "关闭菜单",
  "nav.books": "教材",
  "nav.assignHomework": "布置作业",
  "nav.checkHomework": "批改作业",
  "nav.selfStudyRecord": "自主学习记录",

  "common.back": "返回",
  "common.tryAgain": "重试",
  "common.cancel": "取消",
  "common.done": "完成",
  "common.clearAll": "全部清除",
  "common.selectAll": "全选",
  "common.delete": "删除",

  "home.welcome": "{name}，欢迎回来",
  "home.books": "教材",
  "home.books.caption": "浏览所有可布置的项目与课程。",
  "home.classrooms": "班级",
  "home.classrooms.caption": "你的班级与学生。",

  "books.title": "教材",

  "classrooms.title": "班级",
  "classrooms.loadError": "无法从 MyBestUser 加载你的班级。",
  "classrooms.studentCount": "{count} 位学生",
  "classrooms.empty": "你目前没有任教的班级。",
  "classroom.fallbackName": "班级",

  "check.tabHomework": "作业",
  "check.column.title": "作业",
  "check.column.due": "截止日",
  "check.column.assigned": "布置日",
  "check.column.classroom": "班级",
  "check.empty": "您尚未布置任何作业。",
  "check.loadError": "无法加载您布置的作业。",

  "roster.title": "学生",
  "roster.loadError": "无法加载这份名单。",
  "roster.enrolled": "{count} 位在校",
  "roster.neverSignedIn": "尚未登录过",
  "roster.empty": "这个班级还没有学生。",

  "student.fallbackName": "学生",
  "student.homework": "作业",
  "student.homeworkLoadError": "无法加载这位学生的作业。",
  "student.completed": "已完成",
  "student.onTime": "准时",
  "student.overdue": "逾期",
  "student.report": "学习报告",
  "student.score": "自主学习记录",
  "student.reportLoadError": "无法加载这位学生的学习报告。",
  "student.nextFocus": "待加强",
  "student.streak": "连续记录",
  "student.streakDayOne": "{count} 天",
  "student.streakDayOther": "{count} 天",

  "homework.listLoadError": "无法加载这份作业。",
  "homework.listEmpty": "尚未布置任何作业给这位学生。",
  "homework.completedOfTotal": "已完成 {completed}/{total}",
  "homework.submitted": "提交于",
  "homework.due": "截止",
  "homework.progress": "进度",
  "homework.reassign": "重新布置",
  "homework.deleteConfirm": "要删除“{title}”吗？{warning}此操作无法撤销。",
  "homework.deleteWarning": "学生已完成的部分仍会保留在学习记录中。",
  "homework.deleted": "作业已删除",
  "homework.deleteFailed": "无法删除作业",
  "homework.fallbackTitle": "作业",
  "homework.detailLoadError": "无法加载这份作业。",

  "homework.status.done": "已完成",
  "homework.status.overdue": "逾期",
  "homework.status.undone": "未完成",
  "homework.status.late": "迟交",

  "review.assigned": "布置于 {date}",
  "review.started": "开始于 {date}",
  "review.submitted": "提交于 {date}",
  "review.lastPlayed": "最后练习 {date}",
  "review.dueOn": "截止 {date}",
  "review.slidesDone": "{completed}/{total} 张",
  "review.score": "分数",
  "review.slideCount": "{count} 张",
  "review.played": "已练习",
  "review.previousSlide": "上一张",
  "review.nextSlide": "下一张",
  "review.slideOfTotal": "第 {current} / {total} 张",
  "review.pauseAutoplay": "暂停自动播放",
  "review.playInOrder": "依序播放",
  "review.every": "每",
  "review.seconds": "秒",
  "review.noSlides": "这份作业已经没有任何题目。",
  "review.notPlayed": "这份作业的这一题还没有练习过。",
  "review.slideLocation": "题目位置",

  "assign.title": "布置作业",
  "assign.pickClassroom": "选择要布置的班级。",
  "assign.submit": "布置",
  "assign.assigned": "已布置给 {count} 位学生",
  "assign.failed": "无法布置作业",
  "assign.titleLabel": "名称",
  "assign.titlePlaceholder": "第三周练习",
  "assign.dueLabel": "截止日",
  "assign.slides": "题目",
  "assign.slideCount": "{count} 张",
  "assign.fromLessonOne": "{count} 张，来自 {lessons} 个课程",
  "assign.fromLessonOther": "{count} 张，来自 {lessons} 个课程",
  "assign.chooseSlides": "选择题目",
  "assign.noSlides": "尚未选择题目。打开选择器浏览课程，并预览每一张的样子。",
  "assign.subslideCount": "+{count} 张子题",
  "assign.removeSlide": "移除 {name}",
  "assign.students": "学生",
  "assign.selectedCount": "已选 {count} 位",
  "assign.pickStudentsFirst": "请先选择学生，可选的题目取决于他们。",
  "assign.dot.blocked": "MBU 票券不包含此产品",
  "assign.dot.absent": "从未登录",
  "assign.dot.unverified": "无法连接 MyBestUser，改用最后一次登录记录",
  "assign.hint.notSignedIn": "尚未登录过",
  "assign.hint.checking": "正在检查 MBU 票券…",
  "assign.hint.notCovered": "他们的 MBU 票券未涵盖 {missing}",
  "assign.hint.unverified": "{username} · 票券未验证",

  "library.root": "教材库",
  "library.loadError": "无法加载教材库的这个部分。",
  "library.itemOne": "{count} 个项目",
  "library.itemOther": "{count} 个项目",
  "library.slideOne": "{count} 张",
  "library.slideOther": "{count} 张",
  "library.empty": "这个文件夹是空的。",
  "library.truncated": "各类别仅显示前 {count} 条。打开文件夹以缩小范围。",
  "library.reach.noProduct": "项目未设置产品",
  "library.reach.studentNoProduct": "学生票券不含此产品",
  "library.reach.studentLevelTooLow": "学生等级不足",

  "picker.allGroups": "所有分组",
  "picker.allTags": "所有标签",
  "picker.allTemplates": "所有模板",
  "picker.filterByGroup": "按分组筛选",
  "picker.filterByTag": "按标签筛选",
  "picker.filterByTemplate": "按模板筛选",
  "picker.search": "搜索题目",
  "picker.selectVisible": "选取这 {count} 张",
  "picker.deselectVisible": "取消选取",
  "picker.noMatches": "没有符合这些筛选条件的题目。",

  "lesson.fallbackName": "课程",
  "lesson.slidesLoadError": "无法加载这些题目。",
  "lesson.empty": "这个课程还没有任何题目。",
  "lesson.slideOne": "{count} 张",
  "lesson.slideOther": "{count} 张",

  "slide.fallbackName": "题目",
  "slide.notFoundTitle": "找不到这一张",
  "slide.notFoundBody": "这一张不存在或已被移除。",
  "slide.position": "第 {current} / {total} 张",
  "slide.previous": "上一张",
  "slide.next": "下一张",
  "slide.gridItem": "{name}，第 {number} 张",
  "slide.playsWith": "与这张一起播放",

  "report.performance.title": "表现",
  "report.performance.band0": "继续加油",
  "report.performance.band1": "开始得不错",
  "report.performance.band2": "稳定进步中",
  "report.performance.band3": "表现很好！",
  "report.performance.band4": "火力全开！",
  "report.performance.subLow": "多练习来点燃你的火焰。",
  "report.performance.subMid": "持续练习让火焰更旺。",
  "report.performance.subHigh": "你的火焰正熊熊燃烧！",

  "report.skill.speaking": "口语",
  "report.skill.listening": "听力",
  "report.skill.reading": "阅读",
  "report.skill.grammar": "语法",
  "report.skill.writing": "写作",
  "report.skill.wordRecognition": "词汇",

  "report.insights.title": "学习洞察",
  "report.insights.areaToImprove": "待加强项目",
  "report.insights.strongestSkill": "最强项目",
  "report.insights.locked": "练习量还不足以判断",

  "report.skills.title": "能力分析",
  "report.skills.locked": "练习量还不足以评分",
  "report.skills.provisional": "目前的练习量还很少",
  "report.skills.footnote": "多加练习以提高准确度",

  "report.duration.minutes": "{count} 分钟",
  "report.duration.hoursMinutes": "{hours} 小时 {minutes} 分",
  "report.duration.hours": "{hours} 小时",

  "report.streak.header": "连续记录与进度",
  "report.streak.current": "连续 {count} 天",
  "report.streak.none": "目前没有连续记录",
  "report.streak.noneYet": "尚无连续记录",
  "report.streak.bestOne": "最佳：{count} 天",
  "report.streak.bestOther": "最佳：{count} 天",
  "report.streak.achievement": "{current} / {threshold} 天",

  "report.activity.thisMonth": "本月",
  "report.activity.minPerDay": "每天 {count} 分钟",
  "report.activity.previousMonth": "上个月",
  "report.activity.nextMonth": "下个月",
  "report.activity.previousYear": "前一年",
  "report.activity.nextYear": "后一年",

  "report.day.noPractice": "没有练习记录",
  "report.day.timeUnavailable": "已记录活动，但无法获取练习时间",
  "report.day.minutesPracticed": "练习 {count} 分钟",
  "report.day.hoursMinutesPracticed": "练习 {hours} 小时 {minutes} 分",
  "report.day.hoursPracticed": "练习 {hours} 小时",
  "report.day.newVocabulary": "新单词",
  "report.day.noVocabulary": "这天没有新单词",
  "report.day.close": "关闭当日详情",

  "report.weekly.title": "每周练习张数",
  "report.weekly.empty": "这段期间没有练习记录",
  "report.weekly.previousPeriod": "前六周",
  "report.weekly.nextPeriod": "后六周",
  "report.weekly.barA11y": "{range}：{count} 张",
  "report.weekly.slideOne": "张",
  "report.weekly.slideOther": "张",
  "report.weekly.totalPrefix": "累计练习 ",
  "report.weekly.totalSuffix": " 张",

  "report.lessons.title": "课程分数",
  "report.lessons.empty": "这里还没有内容",
  "report.lessons.itemCountOne": "{count} 项",
  "report.lessons.itemCountOther": "{count} 项",
  "report.lessons.lessonCountOne": "{count} 课",
  "report.lessons.lessonCountOther": "{count} 课",
  "report.lessons.slidesDone": "已完成 {done} / {total} 张",
  "report.lessons.averageScore": "平均 {score}",
  "report.lessons.back": "返回",

  "selfStudy.title": "自主学习记录",
  "selfStudy.pickClassroom": "选择班级，查看学生自己练习的情况。",
  "selfStudy.classroomCaption": "点开资料夹，查看全班各课的表格。",
  "selfStudy.lessons.title": "课程",
  "selfStudy.loadError": "无法载入这个班级的课程。",
  "selfStudy.noAccount": "尚未登入过",
  "selfStudy.progress.label": "全班记录",
  "selfStudy.progress.empty": "这个班级还没有学生。",
  "selfStudy.progress.loadError": "无法载入这些记录。",
  "selfStudy.table.student": "学生",
  "selfStudy.table.total": "总计",
  "selfStudy.table.open": "全班表格",
  "selfStudy.band.strong": "良好",
  "selfStudy.band.mixed": "普通",
  "selfStudy.band.weak": "待加强",
  "selfStudy.band.notStarted": "未开始",

  "readonly.notScored": "尚未评分",
  "readonly.correct": "正确答案：{answer}",
  "readonly.yourAnswer": "你的答案",
  "readonly.feedback": "反馈",
  "readonly.playClip": "播放{label}",
  "readonly.stopClip": "停止播放{label}",
  "readonly.clipUnavailable": "{label}无法播放",
  "readonly.unsupported": "无法显示这一张的细节。",
  "readonly.myRecording": "我的录音",
  "readonly.myRecordingUnavailable": "我的录音无法播放",
  "readonly.myReading": "我的朗读",
  "readonly.myTurn": "我的回应",
  "readonly.myAnswer": "我的答案",
  "readonly.correctAnswer": "正确答案",
  "readonly.wordImage": "单词图片",
  "readonly.perWord": "逐词分数",
  "readonly.promptImage": "题目图片",
  "readonly.promptVideo": "题目视频",
  "readonly.passageImage": "文章图片",
  "readonly.passageVideo": "文章视频",
  "readonly.passageNotSet": "找不到这段文章",
  "readonly.noParagraphs": "这次朗读没有记录任何段落。",
  "readonly.paragraph": "第 {number} 段",
  "readonly.quiz": "测验",
  "readonly.theSound": "这个音",
  "readonly.playTheSound": "播放这个音",
  "readonly.stopTheSound": "停止播放这个音",
  "readonly.playMySoundRecording": "播放我读 {phoneme} 的录音",
  "readonly.stopMySoundRecording": "停止播放我读 {phoneme} 的录音",
  "readonly.options": "选项",
  "readonly.whatYouTyped": "你输入的答案",
  "readonly.theClip": "这段影音",
  "readonly.noCheckpoints": "没有记录任何检查点的答案。",
  "readonly.questionNotSet": "找不到这个问题",
  "readonly.answer": "答案",
  "readonly.conversation": "对话",
  "readonly.noTurns": "这次对话没有记录任何回应。",
  "readonly.assessment": "评量",
  "readonly.dimension.grammar": "语法",
  "readonly.dimension.wordChoice": "用词",
  "readonly.dimension.understanding": "理解力",
  "readonly.dimension.communication": "沟通力",
  "readonly.dimension.pronunciation": "发音",
  "readonly.noCanvasAnswers": "这个活动没有记录详细答案。",
  "readonly.noWriting": "这次练习没有保存任何书写记录。",
  "readonly.wordNumber": "第 {number} 个字",
  "readonly.writingOf": "{text} 的书写",
  "error.accessLocked": "此账号已暂停使用，请联系管理员。",
  "error.rateLimited": "请求次数过多，请稍候再试。",
  "error.rateLimitedMinutes": "请求次数过多，请于约 {minutes} 分钟后再试。",
  "readonly.yourWriting": "你的书写",
};
